import clsx from "clsx";
import { useTranslation } from "react-i18next";

import classes from "./styles.module.scss";

import { IconButton } from "@components/molecules/iconButton";
import { Icon } from "@components/atoms/icons";
import type { IAppointmentCardActionProps } from "@components/organisms/appointmentCard/components/appointmentCardActions/types";
import { useInviteGuest } from "@components/organisms/videoVisit";
import type { IAppointmentCardVariants } from "@components/organisms/appointmentCard/components/appointmentCardBottom";

/**
 * AppointmentCardActions component displays actions for an appointment card.
 *
 * @returns AppointmentCardActions The rendered AppointmentCardActions component.
 */
export function AppointmentCardActions({
  variant,
  // canPrint,
  // canDownload,
  canReschedule,
  canViewStoredResult,
  canEditIntakeForm,
  onEditIntakeForm,
  onView,
  onReschedule,
  canViewIntakeForm,
  onPrint,
  onDownload,
  canJoin,
  id,
}: IAppointmentCardActionProps) {
  const { t } = useTranslation(["common", "form"]);

  const appointmentData: IAppointmentCardVariants[] = [
    "followup",
    "orders",
    "referral",
    "prescription",
  ];

  const isAppointmentData = appointmentData?.includes(variant);

  const { inviteGuest } = useInviteGuest();

  return (
    <div className={clsx(classes.actions)}>
      {variant === "appointment" && (
        <>
          {canReschedule && (
            <IconButton
              icon={<Icon name={"Calendar"} />}
              label={t("reschedule")}
              transparent
              onClick={onReschedule}
            />
          )}
          {canViewIntakeForm && (
            <IconButton
              icon={<Icon name={"PenNewSquare"} />}
              label={
                canEditIntakeForm
                  ? t("edit_intake_form")
                  : t("view_intake_form")
              }
              transparent
              onClick={onEditIntakeForm}
            />
          )}
          {canViewStoredResult && (
            <IconButton
              icon={<Icon name={"Eye"} />}
              label={t("view-report")}
              transparent
              onClick={onView}
            />
          )}
          {canJoin && (
            <IconButton
              icon={<Icon name={"UserPlus"} />}
              label={t("form:add_guest")}
              transparent
              onClick={() => inviteGuest(id)}
            />
          )}
        </>
      )}
      {isAppointmentData && (
        <>
          {/**  {canPrint && (
            <IconButton
              icon={<Icon name={'PrinterMinimalistic'} />}
              label={t('print')}
              transparent
            />
          )}
          {canDownload && (
            <IconButton
              icon={<Icon name={'DownloadSquare'} />}
              label={t('download')}
              transparent
            />
          )} */}
        </>
      )}
      {variant === "past-appointment" && (
        <>
          {/** {canPrint && (
            <IconButton
              icon={<Icon name={'PrinterMinimalistic'} />}
              label={t('print')}
              transparent
            />
          )}
          {canDownload && (
            <IconButton
              icon={<Icon name={'DownloadSquare'} />}
              label={t('download')}
              transparent
            />
          )} */}
        </>
      )}
      {variant === "summary-note" && (
        <>
          {/**
           *  {canPrint && (
            <IconButton
              icon={<Icon name={'PrinterMinimalistic'} />}
              label={t('print')}
              transparent
            />
          )}
          {canDownload && (
            <IconButton
              icon={<Icon name={'DownloadSquare'} />}
              label={t('download')}
              transparent
            />
          )}
           */}
          {canViewStoredResult && (
            <IconButton
              icon={<Icon name={"Eye"} />}
              label={t("view")}
              transparent
            />
          )}
        </>
      )}
      {onDownload && (
        <IconButton
          icon={<Icon name={"DownloadSquare"} />}
          label={t("download")}
          transparent
          onClick={onDownload}
        />
      )}
      {onPrint && (
        <IconButton
          icon={<Icon name={"PrinterMinimalistic"} />}
          label={t("print")}
          transparent
          onClick={onPrint}
        />
      )}
    </div>
  );
}
